/* eslint-disable react/prop-types */
import { TableCell, TableRow } from '@mui/material';
import SoftBadge from 'components/SoftBadge';
import useModal from "hooks/useModal";
import React from 'react'
import fixTableCellWidth from 'utils/fixTableCellWidth';
import separate from 'utils/separate';
import GhollakCalculateDetailModal from './GhollakCalculateDetailModal';

function Row(props) {
    const { row } = props;
    return (
        <React.Fragment>
            <TableRow
                sx={{ "& > *": { borderBottom: "unset" }, backgroundColor: row.id % 2 === 1 ? "" : "rgba(204,204,204,0.1)" }}>
                <TableCell className="tablecell" align="left" title={row.ghollakName}
                    style={fixTableCellWidth("160px")}>{row.ghollakName}</TableCell>
                <TableCell className="tablecell" align="left" title={row.IOName}
                    style={fixTableCellWidth("170px")}>{row.IOName}</TableCell>
                <TableCell className="tablecell" align="left" title={separate(Number(row.avgBalance))}
                    style={fixTableCellWidth("150px")}>{separate(Number(row.avgBalance).toFixed(0))}</TableCell>
                <TableCell className="tablecell" align="left" title={separate(Number(row.avgOppBalance))}
                    style={fixTableCellWidth("160px")}>{separate(Number(row.avgOppBalance).toFixed(0))}</TableCell>
                <TableCell className="tablecell" align="left" title={separate(Number(row.sumDailyInterest))}
                    style={fixTableCellWidth("160px")}>{separate(Number(row.sumDailyInterest).toFixed(0))}</TableCell>
                <TableCell className="tablecell" align="left"
                    style={fixTableCellWidth("160px")}>{row.operations}</TableCell>
            </TableRow>
        </React.Fragment>
    );
}
function createData(id, ghollakName, IOName, avgBalance, avgOppBalance, sumDailyInterest, operations) {
    return {
        id,
        ghollakName,
        IOName,
        avgBalance,
        avgOppBalance,
        sumDailyInterest,
        operations
    };
}

export default function MinimalTableBody({ data }) {
    const [modals, updateModal, closeModal] = useModal({
        dataDetails: { state: false },
    });
    const closeDataDetailsModal = () => closeModal("dataDetails");

    const rows = data.map(item => createData(item.id, item?.ghollak_name, item?.investment_opportunity_name, item.avg_balance,
        item.avg_opportunity_balance, item.sum_daily_interest, <section>
        <SoftBadge variant="contained"
            onClick={() => updateModal("dataDetails", { state: true, item })}
            badgeContent="جزئیات"
            style={{ cursor: "pointer" }}
            color="secondary" size="xs" />
    </section>
    ));
    return (
        <>
            {rows.map((row) => (
                <Row key={row.id} row={row} />
            ))}
            {modals.dataDetails.state && <GhollakCalculateDetailModal modalInfo={modals.dataDetails} closeModal={closeDataDetailsModal} />}
        </>
    )
}
